import { A } from '@ember/array';
import { isGroup } from 'ember-power-select/utils/group-utils';
export function isPowerSelectGroup(option) {
  return option != null && typeof option === 'object' && option.groupName != null && option.options != null;
}
export function flattenOptions(options) {
  return options.reduce((acc, option) => {
    if (isPowerSelectGroup(option)) {
      return [...acc, ...flattenOptions(option.options)];
    }
    return [...acc, option];
  }, []);
}

// Slightly modified version of ember-power-select's filterOptions
// https://github.com/cibernox/ember-power-select/blob/c18e0d9ea5c0ad9cea8acdca0306e56376a7bb2b/addon/utils/group-utils.ts#L145
export function filterOptions(options, text, matcher, skipDisabled = false) {
  let opts = A();
  let highlightedOption = null;
  let {
    length
  } = options;
  for (let i = 0; i < length; i++) {
    // eslint-disable-next-line ember/no-array-prototype-extensions
    let entry = options.objectAt ? options.objectAt(i) : options[i];
    if (!skipDisabled || !entry.disabled) {
      if (isGroup(entry)) {
        let suboptions = filterOptions(entry.options, text, matcher, skipDisabled);
        if (suboptions.options.length > 0) {
          let groupCopy = {
            groupName: entry.groupName,
            options: suboptions,
            disabled: entry?.disabled
          };
          opts.push(groupCopy);
        }
      } else if (matcher(entry, text) === 2) {
        // ember-power-select pushes all matched entries to the end of the filtered options.
        // We change that to push filtered match to the front of the options and make it highlighted.
        opts.unshift(entry);
        highlightedOption = 0;
      } else if (matcher(entry, text) >= 0) {
        opts.push(entry);
      }
    }
  }
  return {
    options: opts,
    highlightedOption
  };
}